import httpClient from '~/http/services/pos';
import { RestaurantItem } from '~/types/restaurant';

export const fetchRestaurants = () => {
  return httpClient.get<{ restaurants: RestaurantItem[] }>(
    '/api/v2/users/me/restaurants'
  );
};
